import { AxiosResponse, AxiosError } from 'axios'
import { navigate } from '~routes'

export const handleFulfilled = (success: AxiosResponse) => {
  return success
}

export const handleRejected = (error: AxiosError) => {
  if (error.response.status < 400 || error.response.status >= 500)
    navigate('/erro/envio-dados')

  return Promise.reject(error)
}
